// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/stream
import { alpha, Box, Paper, Typography, useMediaQuery } from "@mui/material";
import { linearGradientDef } from "@nivo/core";
import { ResponsiveLine, ResponsiveLineCanvas } from "@nivo/line";
import dayjs from "dayjs";

const useStyles = ({ theme, md, sm }) => ({
  fontsizeTicks: {
    fill: theme.palette.text.primary, // Cor do texto dos ticks
    fontSize: md ? 12 : 11, // Tamanho do texto dos ticks
    //fontWeight: 500,
  },
});

const getMinMaxY = (data) => {
  if (!data || data.length === 0) return { minY: null, maxY: null };
  const yValues = data.map((item) => item.portCount);
  const minY = Math.min(...yValues);
  const maxY = Math.max(...yValues);
  const range = maxY - minY; // Diferença entre máximo e mínimo
  const padding = range * 0.1; // 30% do intervalo

  return {
    minY: minY - padding,
    maxY: maxY + padding,
  };
};

const formattedData = (data) => {
  if (data.length === 0) return [];
  return [
    {
      id: "Portas",
      data:
        data.map((item) => ({
          x: new Date(item.time_group.replace("Z", "")), // Renomeando 'time_group' para 'x'
          y: item.portCount, // Renomeando 'portCount' para 'y'
          unit: item.unit, // Mantendo a unidade
        })) || [],
    },
  ];
};

const ResponsiveArea = ({ data, theme }) => {
  const md = useMediaQuery(theme.breakpoints.up("mdl"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const styles = useStyles({ theme, sm, md });
  const countSticks = md ? 5 : 3; // Número de ticks no eixo X

  return (
    <ResponsiveLineCanvas
      //curve="monotoneX"
      enableArea={true} // Ativa a área preenchida
      areaOpacity={0.15} // Transparência da área
      areaBaselineValue={getMinMaxY(data)?.minY} // Define a linha de base da área
      enableGridX={false} // Desativa a grade X
      data={formattedData(data)}
      margin={{ top: 5, right: 25, bottom: 75, left: 70 }}
      xScale={{ type: "time" }}
      yScale={{
        type: "linear",
        min: getMinMaxY(data)?.minY,
        max: getMinMaxY(data)?.maxY,
      }}
      theme={{
        grid: {
          //so funciona no modo svg
          line: {
            stroke: theme.palette.text.primary, // Cor das linhas do grid
            strokeWidth: 0.1, // Espessura das linhas do grid
            //strokeDasharray: "4 4", // Linhas tracejadas (ajuste para linha contínua)
          },
        },
        axis: {
          legend: {
            text: {
              fill: theme.palette.text.shadow, // Cor do texto da legenda
              fontSize: "0.8rem",
              fontWeight: 500,
            },
          },
          ticks: {
            text: styles.fontsizeTicks, // Estilo do texto dos ticks
          },
        },
      }}
      defs={[
        linearGradientDef("gradientA", [
          { offset: 0, color: theme.palette.easyLog.primary },
          { offset: 100, color: alpha(theme.palette.easyLog.primary, 0.2) },
        ]),
      ]}
      fill={[{ match: "*", id: "gradientA" }]}
      axisLeft={{
        legend: "Quantidade de Portas",
        legendOffset: -65,
        legendPosition: "middle",
      }}
      axisBottom={{
        legend: "Tempo",
        legendOffset: 40,
        legendPosition: "middle",
        tickValues:
          data.length > 5
            ? formattedData(data)[0]
                ?.data.map((d, i) =>
                  i % Math.ceil(data.length / countSticks) === 0 ? d.x : null
                )
                .filter(Boolean)
            : data.length,
        format: data[0]?.unit == "day" ? "%d/%m/%Y" : "%d/%m/%Y %H:%M",
      }}
      pointBorderWidth={0}
      pointSize={data.length < 1000 ? 2 : 0}
      lineWidth={1.5}
      colors={[theme.palette.easyLog.primary]}
      useMesh={data.length != 0}
      tooltip={(e) => {
        let date = dayjs(e.point.data.x.toISOString());
        date =
          e.point.data.unit == "day"
            ? date.format("DD/MM/YYYY")
            : date.format("DD/MM/YYYY HH:mm");
        return (
          <Paper
            sx={{
              padding: "10px",
              display: "flex",
              alignItems: "center",
              zIndex: 100,
              background: theme.palette.background.default,
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{ color: theme.palette.text.primary, fontSize: "0.875rem" }}
            >
              {e.point.data.y} Portas
            </Typography>
            <Typography
              sx={{ color: theme.palette.text.primary, fontSize: "0.875rem" }}
            >
              {date}
            </Typography>
          </Paper>
        );
      }}
    />
  );
};

export default ResponsiveArea;
